/**
 * Cohort SEO copy — short editorial paragraph per cohort so the
 * `/rankings/{country}/{subject}/{cohort}` deep pages read as native
 * content rather than templated stubs. Rendered above the leaderboard
 * table whenever a cohort filter is active.
 *
 * Kept short (2 sentences max) so it doesn't dilute the leaderboard's
 * scannability while still giving Google enough unique content to
 * index the page differently from the unfiltered `/rankings/{country}/
 * {subject}` variant.
 */

export const COHORT_BLURBS = {
  "russell-group": {
    headline: "Why the Russell Group matters",
    body:
      "The Russell Group is the UK's 24-strong research-intensive club — home to 68% of UK Nobel laureates, the majority of Doctoral Training Partnerships, and every UK medical school that ranks in the QS global top-100. Filtering this leaderboard to the Russell Group cut isolates the research-first universities from the wider UK cohort — useful for families weighing academic ambition and PhD pipelines above regional access or teaching-focused institutions.",
  },
  "ivy-plus": {
    headline: "Why Ivy Plus matters",
    body:
      "\"Ivy Plus\" is the working definition used by the Chetty-Friedman-Saez mobility papers: the 8 Ivies plus MIT, Stanford, Chicago, Duke, Northwestern, Johns Hopkins and Caltech. It captures the US universities where families report the highest need-blind aid, the largest per-student endowments, and the tightest recruiting relationships with McKinsey / Goldman Sachs / the frontier AI labs. Filtering to Ivy Plus surfaces that cohort's internal pecking order — different from the wider US ranking, which mixes state flagships and LACs.",
  },
  "go8": {
    headline: "Why the Group of Eight matters",
    body:
      "The Go8 (Melbourne, Sydney, ANU, UNSW, Monash, UQ, UWA, Adelaide) is Australia's research-intensive federation — every Go8 member ranks in the QILT top-quartile for graduate outcomes and holds a Medical / Dental faculty. Families targeting professional degrees (Medicine, Law, Engineering, Business) or PhD-track career paths use this filter to slice the honest Australian universe from the wider ATAR-set.",
  },
  "u15": {
    headline: "Why the U15 matters",
    body:
      "Canada's U15 (Toronto, McGill, UBC, McMaster, Alberta, Montréal, Waterloo, Western, Calgary, Queen's, Ottawa, Manitoba, Laval, Dalhousie, Saskatchewan) accounts for over 80% of competitive research funding awarded by SSHRC / NSERC / CIHR. This filter is the honest cut for families weighing research pipelines, Medical / Law / Dental admits, and post-graduation stay-back permits at the country's most-resourced institutions.",
  },
  "grandes-ecoles": {
    headline: "Why the Grandes Écoles matter",
    body:
      "France's Grandes Écoles operate outside the public-university system and dominate French employer relationships: 42% of CAC 40 CEOs graduated from Polytechnique / HEC / Sciences Po / ENA. Filtering this leaderboard to the 13-institution cohort — the top engineering (Polytechnique, CentraleSupélec, Ponts), business (HEC, ESSEC, ESCP, INSEAD) and humanities (ENS Paris/Lyon, Sciences Po) écoles — captures the ranking family that actually determines French elite hiring.",
  },
};
